<template>
  <!-- 资讯管理页面 -->
  <div class="informationManage">
    <div class="pageTop">
      <div class="titleBox">
        <div class="left">
          <van-icon name="arrow-left" size="28" @click="goBack" />
        </div>
        <div class="middle">
          {{ $route.meta.title }}
        </div>
        <div class="right">
          <van-dropdown-menu>
            <van-dropdown-item ref="dropDownMenuitem" @open="openMenu">
              <template slot="title">
                <div class="right-nav">
                  <img class="imgLeft" src="../../assets/icon/shaixuan.png" />
                </div>
              </template>
              <div style="height: 100%; z-index: 999">
                <van-form>
                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.subject" name="标题" label="标题" placeholder="请输入" autocomplete="off" />
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.message" name="正文内容" label="正文内容" placeholder="请输入(关键字模糊搜索)"
                      autocomplete="off" />
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="typeName" is-link readonly label="文章标签" placeholder="请选择文章标签"
                      @click="showArticleTag = true" />
                  </div>

                  <div style="z-index: 8">
                    <van-popup v-model="showArticleTag" round position="bottom">
                      <van-picker title="文章标签" show-toolbar :columns="tagList" @cancel="showArticleTag = false"
                        @confirm="okArticleTag" />
                    </van-popup>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="examineName" is-link readonly label="审核评论" placeholder="请选择审核评论"
                      @click="showExamine = true" />
                  </div>

                  <div style="z-index: 8">
                    <van-popup v-model="showExamine" round position="bottom">
                      <van-picker title="审核评论" show-toolbar :columns="examineList" @cancel="showExamine = false"
                        @confirm="okArticleExamine" />
                    </van-popup>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="pgcName" is-link readonly label="PGC账号" placeholder="请选择PGC账号"
                      @click="showPgc = true" />
                  </div>

                  <div style="z-index: 8">
                    <van-popup v-model="showPgc" round position="bottom">
                      <van-picker title="PGC账号" show-toolbar :columns="pgcList" @cancel="showPgc = false"
                        @confirm="okPgc" />
                    </van-popup>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="invisibleName" is-link readonly label="文章状态" placeholder="请选择文章状态"
                      @click="showArticleState = true" />
                  </div>

                  <div style="z-index: 8">
                    <van-popup v-model="showArticleState" round position="bottom">
                      <van-picker title="文章状态" show-toolbar :columns="stateList" @cancel="showArticleState = false"
                        @confirm="okArticleStatus" />
                    </van-popup>
                  </div>
                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.pid" name="资讯PID" label="资讯PID" placeholder="请输入" autocomplete="off" />
                  </div>
                </van-form>
                <div class="btnRow">
                  <van-button class="resetBtn" round type="default" @click="reset"
                    style="border: 1px solid black">重置</van-button>
                  <van-button class="okBtn" round style="background: rgb(72, 113, 192); color: white" @click="submitModal"
                    size="normal">确定</van-button>
                </div>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    </div>
    <!-- 资讯管理列表 -->
    <div class="pageList">
      <!-- 列表页 -->
      <div style="margin-top: 50px">
        <van-pull-refresh v-model="loadDataing" @refresh="onRefresh" loading-text="内容刷新中..." success-text="刷新成功">
          <van-list v-model="loading" :finished="finished" @offset="100" loading-text="内容加载中..."
            finished-text="—————— 没有更多了 ————————" @load="onLoad" :immediate-check="false">
            <div class="box" v-for="item in allList" :key="item.pid" @click="goDetail(item)">
              <div class="topRow">
                <div class="topRowLeft">
                  <div>
                    <img class="touXiangImg" :src="item.banner_image" mode="" />
                  </div>
                  <div class="headLeft">
                    <div class="name">
                      {{ item.author }}
                    </div>
                    <div>
                      <div class="car">
                        {{ item.articleType }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="topRowRight" :style="{ 'color': caseFieldColorValue(item.invisible) }">
                  {{ caseFieldValue(item.invisible) }}
                </div>
              </div>
              <div class="content">
                {{ item.detail.subject }}
              </div>
              <div class="timeBox">
                <div class="time">
                  {{ item.dateline }}
                </div>
                <div class="operation">
                  <div>
                    <img src="../../assets/icon/xin-xi.png" alt="" class="listFooterRightImg" /><span
                      class="listFooterRightNum">
                      {{ item.comments }}
                    </span>
                  </div>
                  <div>
                    <img src="../../assets/icon/zan.png" alt="" class="listFooterRightImg" /><span
                      class="listFooterRightNum">
                      {{ item.praises }}</span>
                  </div>
                  <div>
                    <img src="../../assets/icon/yan-jing.png" alt="" class="listFooterRightImg" /><span
                      class="listFooterRightNum"> {{ item.views }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>

      <!-- <div class="noMore">———————— 没有更多了 ————————</div> -->
    </div>
  </div>
</template>
<script>
import {
  transFormatDate,
  getNowDay,
  getYesterday,
} from "../../common/js/utils";
import { Toast, Dialog } from "vant";
import { listInformationAPI } from "@/api/informationManage";
export default {
  name: "InformationManage",
  data() {
    return {
      showStartTime: false,
      startTime: "",
      endTime: "",
      showEndTime: false,
      showPopoverTop: false,
      currentDate: new Date(),
      maxDate: new Date(),
      showArticleState: false, // 文章状态底部弹框
      showArticleTag: false, // 文章标签底部弹框
      showExamine: false, // 审核评论底部弹框
      showPgc: false, // pgc账号底部弹框
      radioExamine: "", // 审核评论
      radioTag: "", // 文章标签绑定值
      radioPgc: "", // pgc绑定值
      authorid: "", // pgc筛选框值
      showOver: false,
      examineList: [
        { value: "", text: "请选择审核评论" },
        { value: "0", text: "无需审核" },
        { value: "1", text: "审核" },
      ], // 是否审核评论
      tagList: [
        { value: "", text: "请选择文章标签" },
        { value: "1", text: "pgc资讯" },
        { value: "3", text: "公众号文章" },
        { value: "3", text: "专区资讯" },
      ], // 文章标签
      stateList: [
        { value: "", text: "请选择文章状态" },
        { value: "1", text: "发布" },
        { value: "0", text: "待审核" },
        { value: "-3", text: "审核不通过" },
      ], // 文章状态
      pgcList: [], // PCG账号
      searchVal: "", // 搜索的字
      username: "",
      uid: "",
      mobile: "",
      show: false,
      fieldValue: "", // 文章状态
      radio: "1",
      allList: [],
      loadDataing: false, // 下拉刷新是否处于加载中状态
      loading: false, //  列表是否处于加载状态，加载过程中不触发load事件
      finished: false, //  是否已加载完成，加载完成后不再触发load事件
      total: 0, // 总共多少条
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      nodata: false, // 请求接口是否没有数据
      typeName: "", // 文章标签内容
      pgcName: "", // pgc内容
      invisibleName: "", // 文章状态显示内容
      examineName: "", // 审核评论
      searchData: {
        curr: 1,
        nums: 10,
        subject: "", // 标题
        message: "", // 正文内容
        type: "", // 文章标签id
        authorid: "",
        comment_audit: "", // 审核评论
        invisible: "", // 文章状态
        pid: "", // 资讯pid
        // isTop: false, // 是否置顶
      },
      scroll: 0,
    };
  },
  created() {
    this.$root.$children[0].keepList = ["InformationManage"];
    this.loadPcg();
  },
  mounted() {
    this.getData();
  },
  activated() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = this.scroll;
    });
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(oldVal);
        if (
          (oldVal?.name === "InformationManageDetail" || oldVal === undefined) &&
          this.$route.query.source === "informationManageDetail"
        ) {
          this.searchData.curr = 1;
          this.searchData.nums = 10;
          this.pageView(this.searchData);
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadPcg() {
      this.pgcList.push({ text: "请选择PGC账号", value: "" });
      if (localStorage.getItem("pgcList") != null) {
        var list = JSON.parse(localStorage.getItem("pgcList"));
        list.map((item) => {
          this.pgcList.push({ text: item.name, value: item.value });
        });
      }
    },
    getData() {
      this.reset();
      this.searchData.curr = 1;
      this.searchData.nums = 10;
      this.pageView(this.searchData);
    },
    getStartTime(val) {
      this.startTime = transFormatDate(val);
      this.showStartTime = false;
    },
    getEndTime(val) {
      this.endTime = transFormatDate(val);
      this.showEndTime = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      }
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    goBack() {
      this.$router.push({ path: "/" });
    },
    caseFieldValue(state) {
      let str = "";
      this.stateList.forEach((item) => {
        if (state + "" === item.value) {
          str = item.text;
        }
      });
      return str || "";
    },
    caseFieldColorValue(state) {
      const stateList = {
        "1": "rgb(0, 193, 0)",
        "0": "#d6d62f",
        "-3": "red",
      };
      return stateList[state] ? stateList[state] : "";
    },
    // 确定文章状态
    okArticleStatus(data) {
      this.invisibleName = !data.value ? '' : data.text;
      this.searchData.invisible = data.value;
      this.showArticleState = false;
    },
    // 确定文章标签
    okArticleTag(data) {
      this.typeName = !data.value ? '' : data.text;
      this.searchData.type = data.value;
      this.showArticleTag = false;
    },
    // 确定pgc
    okPgc(data) {
      this.pgcName = !data.value ? '' : data.text;
      this.searchData.authorid = data.value;
      this.showPgc = false;
    },
    // 确定审核评论
    okArticleExamine(data) {
      this.examineName = !data.value ? '' : data.text;
      this.searchData.comment_audit = data.value;
      this.showExamine = false;
    },
    openMenu() {
      // this.reset();
      this.startTime = this.startTime ? this.startTime : getYesterday();
      this.endTime = this.endTime ? this.endTime : getNowDay();
    },
    reset() {
      this.searchData.subject = "";
      this.searchData.message = "";
      this.typeName = "";
      this.searchData.type = "";
      this.searchData.pid = "";
      this.pgcName = "";
      this.examineName = "";
      this.searchData.comment_audit = "";
      this.searchData.invisible = "";
      this.invisibleName = "";
      this.searchData.authorid = "";
      // this.searchData.isTop = false;
    },
    openPop() {
      this.showOver = true;
      console.log("点击打开");
    },
    onSearch(val) {
      Toast(val);
    },
    // 下拉刷新(相当于重新请求第一页)
    onRefresh() {
      this.searchData.curr = 0;
      this.allList = [];
      this.loadDataing = true;
      this.onLoad();
    },
    pageView(params) {
      this.finished = false;
      this.loading = true;
      Toast.loading({ message: "数据加载中...", forbidClick: true });
      listInformationAPI(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.allList = res.data?.data || [];
            this.total = res.data.count;
          }
          if (this.allList?.length === this.total) {
            this.finished = true;
          }
          this.loading = false;
          this.loadDataing = false;
        })
        .finally(() => {
          Toast.clear();
        });
    },
    getList(data) {
      data.data.map((item) => {
        this.allList.push({
          ...item,
        });
      });
    },
    // 滚动条与底部距离小于 offset 时触发
    onLoad() {
      this.finished = false;
      this.loading = true;
      let data = this.searchData;
      this.searchData.curr++;
      listInformationAPI(data).then((res) => {
        if (res.data.code === 0) {
          this.getList(res.data);
          this.total = res.data.count;
        }
        if (this.allList?.length === this.total) {
          this.finished = true;
        }
        this.loading = false;
        this.loadDataing = false;
        Toast.clear();
      });
    },
    searchInput() {
      console.log(this.searchVal, "搜索框的值");
    },
    openDialog() {
      this.showPopoverTop = !this.showPopoverTop;
    },
    goDetail(item) {
      let vanListScroll = document.documentElement.scrollTop;
      this.scroll = vanListScroll;
      let str = JSON.stringify(item);
      this.$router.push({
        path: "/InformationManageDetail",
        query: { item: str },
        // query: { pid: item.pid,author:item.author, subject:item.detail.subject,},
      });
    },
    submitModal() {
      this.searchData.curr = 1;
      this.searchData.nums = 10;
      this.$refs.dropDownMenuitem.toggle();
      this.pageView(this.searchData);
    },
    selectPopover(action) {
      if (action.text === "通过") {
        Dialog.confirm({
          title: "操作",
          message: "你确定审核通过该帖子吗？",
        })
          .then(() => {
            Toast.success("通过成功");
          })
          .catch(() => { });
      } else if (action.text === "不通过") {
        Dialog.confirm({
          title: "操作",
          message: "你确定审核不通过该帖子吗？",
        })
          .then(() => {
            Toast.success("不通过成功");
          })
          .catch(() => { });
      } else if (action.text === "推荐") {
        Toast.success("推荐");
      } else if (action.text === "创单") {
        Toast.success("创单");
      } else {
        Toast.success("加圈");
      }
    },
  },
};
</script>
<style scoped lang="less">
.informationManage {
  .pageTop {
    position: fixed;
    width: 100%;
    height: 100px;
    left: 0;
    top: 0;
    z-index: 10;

    .titleBox {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(72, 113, 192);
      color: white;
      font-size: 36px;
    }

    /deep/.van-dropdown-menu__bar {
      background: rgb(72, 113, 192);
    }

    /deep/.van-dropdown-menu__item {
      background: rgb(72, 113, 192);
    }

    .right {
      color: black;
    }

    .rightBox {
      position: fixed;
      left: 0px;
      top: 100px;
      height: 300px;
    }

    .imgLeft {
      width: 52px;
      height: 52px;
    }

    /* 弹框层样式 */
    .bottomModal {
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 36px;
    }

    .radioItem {
      height: 120px;
      line-height: 120px;
      font-size: 30px;
    }

    .formItemBox {
      margin: 12px 0px;
    }

    .btnRow {
      display: flex;
      flex-wrap: nowrap;
      widows: 100%;
      justify-content: space-around;
      margin: 10px;

      //   padding: 0px 20px;
      .resetBtn {
        width: 250px !important;
      }

      .okBtn {
        width: 250px !important;
      }
    }

    .text {
      margin-left: 32px;
      font-size: 32px;
      font-weight: 600;
    }

    .over {
      margin-top: 100px;
    }
  }

  .pageList {
    position: relative;

    // 列表内容样式
    .boxPop {
      padding: 0px 30px;
      height: 260px;
      padding: 32px 0px;
      border-bottom: 1px solid gray;
      background-color: rgba(0, 0, 0, 0.1);
      opacity: 0.8;
    }

    .box {
      padding: 0px 30px 30px 30px;
      min-height: 260px;
      margin: 32px 0px;
      border-bottom: 2px solid #ececec;
    }

    .topRow {
      display: flex;
      justify-content: space-between;

      .topRowLeft {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .touXiangImg {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }

        .headLeft {
          margin-left: 30px;

          .name {
            font-weight: 500;
            font-size: 30px;
          }

          .car {
            padding: 0px 12px;
            color: #b77d43;
            background-color: #f4f0e4;
            height: 40px;
            line-height: 40px;
            font-size: 26px;
            text-align: center;
            min-width: 105px;
            margin-top: 8px;
            // border-radius: 32px;
          }
        }
      }

      .topRowRight {
        color: red;
        font-size: 26px;
        margin-top: 10px;
      }
    }

    .content {
      margin: 20px 0px;
      font-size: 28px;
    }

    .timeBox {
      display: flex;
      justify-content: space-between;
      height: 80px;
      align-items: center;
      font-size: 26px;
      color: #969799;

      .operation {
        display: flex;
        justify-content: flex-end;

        div {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 16px;

          .listFooterRightImg {
            width: 42px;
            height: 42px;
          }

          .listFooterRightNum {
            display: inline-block;
            margin-left: 5px;
            height: 45px;
            line-height: 45px;
          }
        }
      }
    }

    .headBox {
      position: fixed;
      top: 100px;
      left: 0;
      width: 100%;
      z-index: 8;
      display: flex;
      align-items: center;
    }

    /* 弹框层样式 */
    .bottomModal {
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 36px;
    }

    .radioItem {
      height: 120px;
      line-height: 120px;
      font-size: 30px;
    }

    .btnRow {
      display: flex;
      flex-wrap: nowrap;

      .resetBtn {
        flex: 1;
      }

      .okBtn {
        flex: 2;
      }
    }

    .noMore {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      color: #6b6b6b;
    }

    /deep/.van-overlay {
      // top: calc(100vh-250px);
      top: 250px !important;
    }

    /deep/ .van-popup--top {
      top: 248px !important;
    }
  }
}
</style>